import React, {useState} from 'react';
import {selfcareLogin} from "../../util/request";
import {Link, useNavigate, useLocation, useSearchParams} from "react-router-dom";
import IconButton from "../../components/selfcare/IconButton";
import pushToDataLayer from "../../util/dataLayer";
import SelfcarePageContent from "../../components/selfcare/SelfcarePageContent";
import useLoginCheck, {getRedirectUrl} from "../../util/useLoginCheck";
import LoaderSpinner from '../../components/loaders/LoaderSpinner';
import Routing from "../../Routing.ts";
import IconEyeClosed from "../../components/icons/IconEyeClosed.tsx";
import IconEye from "../../components/icons/IconEye.tsx";
import setTitleAndMetaDescription from "../../components/setTitleAndMetaDescription.tsx";

export default function LoginPage() {
    setTitleAndMetaDescription("Log ind - Mit Hiper", "Log ind i Mit Hiper for at få adgang til dit abonnement, se regninger og administrere dine oplysninger.");

    const [loading, setLoading] = useState<boolean>(false)
    const [email, setEmail] = useState<string>("")
    const [password, setPassword] = useState<string>("")
    const [passwordPreview, setPasswordPreview] = useState<boolean>(false);
    const [rememberMe, setRememberMe] = useState<boolean>(false)

    const [errorMessage, setErrorMessage] = useState<string | null>(null)

    const navigate = useNavigate()
    const location = useLocation();
    const [searchParams] = useSearchParams();

    useLoginCheck()

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setLoading(true)

        selfcareLogin(email, password, rememberMe)
            .then(r => {
                if (r.code !== 201) {
                    setErrorMessage(r.response.error_message as string)
                    pushToDataLayer({
                        event: 'login',
                        status: 'error',
                        message: r.response.error_message as string,
                        remember_me: rememberMe,
                    })
                    return
                }

                pushToDataLayer({
                    event: 'login',
                    status: 'ok',
                    message: '',
                    remember_me: rememberMe,
                    userId: r.response.customer_ids ? r.response.customer_ids[0] : null,
                })

                navigate(getRedirectUrl(searchParams))
            })
            .catch((reason) => {
                pushToDataLayer({
                    event: 'login',
                    status: 'error',
                    message: reason.message,
                    remember_me: rememberMe,
                })
                setErrorMessage("Noget gik galt. Prøv igen")
            })
            .finally(() => setLoading(false))
    }

    return <SelfcarePageContent title={"Log ind i Mit Hiper"} className={`selfcare-page-login`}>

        {errorMessage && <section className="selfcare-messages">
            <div className="selfcare-message-error show">
                <p>{errorMessage}</p>
            </div>
        </section>}

        <div className="selfcare-page-summary">
            {location.state === 'created' ?
                <p>Din bruger blev oprettet! Nu kan du logge ind her.</p>
                :
                <p>
                    Her kan du logge ind i Mit Hiper og få et overblik over dit abonnement og oplysninger.
                    F.eks. kan du se dine seneste regninger og skifte dit betalingskort.
                </p>
            }
        </div>
        <form
            onSubmit={handleSubmit}
            className="selfcare-login-form"
            id="selfcare-login-form"
            noValidate
            rel="nofollow"
        >
            <p>
                <input
                    type="text"
                    name="email"
                    disabled={loading}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    id="selfcare-login__email"
                    placeholder="Email"
                    className=""
                    autoComplete={"username"}
                    required
                />
            </p>
            <p id="selfcare-login__email-suggestion-p" className="selfcare-login__email-suggestion-p">
                Mente du {" "}
                <button id="selfcare-login__email-suggestion-a">
                    <strong id="selfcare-login__email-suggestion"></strong>
                </button>
                ?
            </p>
            <p className='input-with-button'>
                <input
                    type={passwordPreview ? "text" : "password"}
                    name="password"
                    disabled={loading}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    id="selfcare-login__password"
                    placeholder="Adgangskode"
                    className=""
                    autoComplete={"current-password"}
                    required
                />
                <span className="button-container">
                    <IconButton
                        className='icon-button'
                        component={passwordPreview ? IconEyeClosed : IconEye}
                        onClick={() => setPasswordPreview(!passwordPreview)}
                    />
                </span>
            </p>
            {loading ? <LoaderSpinner/> :
                <p className="submit-button-block">
                    <label id="submit-form-button">
                        <input disabled={loading} className="continue-button-submit" type="submit"/>
                        <span className="button teal">
                            <span className="text">Log ind</span>
                        </span>
                    </label>
                </p>
            }
            <p className="with-checkbox">
                <input
                    type="checkbox"
                    id="selface-login__remember_me"
                    name="remember_me"
                    value="1"
                    onClick={() => setRememberMe(!rememberMe)}
                />
                <label className="checkbox-label checkbox-label--montserrat" htmlFor="selface-login__remember_me">
                    Husk mig
                </label>
            </p>
            <Link to={Routing.Selfcare.LoginCreate} className={"selfcare-button-bottom"}>
                Opret bruger eller glemt kode
            </Link>
        </form>
    </SelfcarePageContent>
}
